import gql from "graphql-tag";

export default gql`
  mutation UpdatePart(
    $id: ID!
    $name: String
    $description: String
    $category: String
    $barcode: String
    $quantity: String
    $additionalPartDetails: String
    $siteId: ID
  ) {
    updatePart(
      id: $id
      name: $name
      description: $description
      category: $category
      barcode: $barcode
      quantity: $quantity
      additionalPartDetails: $additionalPartDetails
      siteId: $siteId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/UpdatePart.ts